export default {
  default: () => import("/opt/build/repo/layouts/default.vue")
}